/* @flow */
import React from 'react';
import { connect } from 'react-redux';
import * as Features from 'modules/features';
import type { ToggleFeatureProps } from './types';

/*

`ToggleFeature` is a smart React container that renders its children when the
feature matches a certain value (usually `on`). The ToggleFeature container
is connected to Redux which has all of the enabled featurse preloaded. There is
an optional `untoggledComponent` prop which will render if the match fails.

Matching happens with the javascript `String.match` function which also accepts
a regular expression.  Use at your own peril.

See the `ToggleFeatureView` Container to turn on/off elements at the React
Router level.

How to Use:
```
import { ToggleFeature } from 'trustar-2.0/containers/features';
import { flags as Flags, treatments as Treatments } from 'modules/features';

 <ToggleFeature feature={Flags.DASHBOARD_ENABLED} match={treatments.ON}>
    <NavLink
      name={'Dashboard'}
      to='/dashboard'
      selector='DashboardLink'
      icon={<Icon icon={IconLookup.DB} />}
    />
 </ToggleFeature>
```
*/
class ToggleFeatureComponent extends React.Component {
  props: ToggleFeatureProps;
  static defaultProps = {
    untoggledComponent: <React.Fragment />
  };

  render() {
    const { flagTreatment, match, untoggledComponent, children } = this.props;
    return (
      <React.Fragment>
        {match.match(flagTreatment) ? children : untoggledComponent}
      </React.Fragment>
    );
  }
}

const mapState = (state, ownProps) => ({
  flagTreatment: Features.getters.getFlagTreatment(ownProps.feature)(state)
});

export const ToggleFeature = connect(mapState)(ToggleFeatureComponent);

export default ToggleFeature;



// WEBPACK FOOTER //
// ./web_modules/trustar-2.0/containers/features/ToggleFeature.js